var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('page_enfinish_title')))]),_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('span',{staticClass:"sr-only"},[_vm._v("success:")]),_vm._v(" "+_vm._s(_vm.$t('page_enfinish_info1'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('page_enfinish_info2'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }